import * as z from 'zod';

import { contactQueryLinkerSchema } from '@/_pages/contacts/shared/schemas/contact-query-linker-schema';
import { systemUserQueryLinkerSchema } from '@/_pages/system-users/shared/schemas/system-user-query-linker-schema';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

const noteUserQuerySchema = systemUserQueryLinkerSchema.extend({
  team_member_id: z.number().nullable(),
  team_member: teamMemberQueryLinkerSchema.nullable(),
});

export type NoteUserQuerySchema = z.infer<typeof noteUserQuerySchema>;

export const noteContextTypeSchema = z.enum(['client', 'contact']);

export type NoteContextTypeSchema = z.infer<typeof noteContextTypeSchema>;

export const noteQuerySchema = z.object({
  id: z.number(),
  date: z.string(),
  context_id: z.number(),
  context_type: noteContextTypeSchema,
  client: companyQueryLinkerSchema.nullable(),
  contact: contactQueryLinkerSchema.nullable(),
  user_id: z.number(),
  user: noteUserQuerySchema,
  message: z.string(),
  edited: z.boolean().default(false),
});

export type NoteQuerySchema = z.infer<typeof noteQuerySchema>;

export const noteQueryAllSchema = z.object({
  data: z.array(noteQuerySchema),
});

export type NoteQueryAllSchema = z.infer<typeof noteQueryAllSchema>;
